import { createStructureStatementHandler } from '../../createStructureStatementHandler';
import { getFormName, getPreviewName } from '../../utils/nameFormat';
const productForm = getFormName('Product');
export const removePreviewStmtInstruction = `
#### Remove preview from form

- Syntax: \`remove preview <preview_name> in <form_name>.<field_name>;\`
- Example: \`remove preview ${getPreviewName('Option')} in ${productForm}.options;\`
- Example: \`remove preview ${getPreviewName('Variant')} in ${productForm}.variants;\`


#### Remove preview

- Syntax: \`remove preview <prevview_name>;\`
- Example: \`add view field OptionViewField in ${productForm}.options;\`
- Example: \`add view field VariantViewField in ${productForm}.variants;\`
`;
export const stmtRemovePreview = ({ previewName, formName, fieldName }) => {
    if (formName && fieldName) {
        return `remove preview ${previewName} in ${formName}.${fieldName};`;
    }
    return `remove preview ${previewName};`;
};
export const removePreviewHandler = createStructureStatementHandler({
    type: 'remove preview',
    parse: line => {
        const match = /^remove preview (?<previewName>\w+)( in (?<formName>\w+).(?<fieldName>\w+))?/.exec(line);
        return match?.groups
            ? {
                type: 'remove preview',
                previewName: match.groups.previewName,
                formName: match.groups.formName,
                fieldName: match.groups.fieldName,
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => {
            return it.removePreview({
                previewName: stmt.previewName,
                formName: stmt.formName,
                fieldName: stmt.fieldName,
            });
        });
    },
});
//# sourceMappingURL=RemovePreviewStmt.js.map